"use strict";

IREP.LearningMain = (function () {
    var defaultSearchValue;
    var resultsList;

    var init = function (query, searchFilter, mainPage) {
        resultsList = $(".selResultType").attr("type");

        // loading animation
        defaultSearchValue = query.attr("defaultText");

        $("#searchResultsHolder").on('pjax:start', function () {
            $("#LoadingOverlay").fadeIn("fast");
            $("#searchResultsHolder").fadeTo("fast", 0.08);
            $("#topPagerHolder").fadeTo("fast", 0.08);
        });
        $("#searchResultsHolder").on('pjax:end', function () {
            showListType(resultsList);
            $("#LoadingOverlay").fadeOut(700);
            $("#searchResultsHolder").fadeTo(700, 1);
            $("#topPagerHolder").fadeTo(700, 1);
        });

        // run when the page loads
        showListType(resultsList);

        $('#learningDiv').on('mousedown', '.itemHolder', function (e) {
            if (e.which === 2) {
                var code = $(this).find('[actcode]').attr('actcode');
                var href = IREP.generateSiteLink('/quiz?code=' + code);

                window.location = href;

                return false;
            }
        })

        //Track the learning drop down list filter
        $("#bodyContent_bodyContent_searchFilter").change(function () {
            var value = $(this).val();
            var label = '';
            if (value == 0) {
                label = 'All Learnings';
            } else if (value == 1) {
                label = 'Not Taken';
            } else if (value == 2) {
                label = 'Completed';
            } else if (value == 3) {
                label = 'New Learning';
            }

            IREP.track("Learning", "SearchOption", label, '', '');
        });

        //Track the learning Categories
        $(".category").click(function () {

            var label = $(this).attr('id');

            IREP.track("Learning", "Categories", label, '', '');
        });

        //Track the learning Filters
        $(".tagHeader").click(function () {

            var label = $(this).attr('id');

            IREP.track("Learning", "Filters", label, '', '');
        });


        // swap the deafult Search box text on blur and focus
        query.focus(function () {
            if ($(this).val() == defaultSearchValue) {
                $(this).val("");
            }
        })
         .blur(function () {
             if ($(this).val() == "") {
                 $(this).val(defaultSearchValue);
             }
         })
         .val();

        mainPage.on('clearResults', function () {
            $("#clearLink").click();
        });

        $("#reloadLink").click(function () {
            if (!history.pushState) {
                window.location.href = this.href;
                return false;
            }
        });

        // event handler, can be bubbled up from other controls, sets the hidden fields for category and tags, then calls the reload function
        mainPage.on('loadResults', function (event, actCatId, actTags, pageNum) {
            if (actCatId) {
                $("#actCatId").val($.trim(actCatId));
            }
            if (actTags) {
                $("#actTags").val($.trim(actTags));
            }
            if (pageNum) {
                $("#page").val(pageNum);
            }

            loadResults(query, searchFilter, resultsList);
        });

        // clicking the search button
        $("#learningSearch").click(function () {
            $(this).trigger('loadResults', [null, null, 1]);
        });

        // Enter keypress should trigger the loadresults
        $("#searchForm").keypress(function (e) {
            if (e.which == 13) {
                $(this).trigger('loadResults', [null, null, 1]);
                return false;
            }
        });

        $(".ImgAndTitle").click(function () {
            resultsList = $(this).attr("type");
            showListType(resultsList);
        });

        $(".ImgOnly").click(function () {
            resultsList = $(this).attr("type");
            showListType(resultsList);
        });

        $(".Details").click(function () {
            resultsList = $(this).attr("type");
            showListType(resultsList);
        });

        mainPage.resize(function () { NextArrow(); });
    };

    var showListType = function (resultListType) {
        $("#LoadingOverlay").fadeIn("fast");
        var tl = new TimelineMax();
        if (resultListType == 0) {
            // image and title
            $(".ImgAndTitle").addClass("selResultType");
            $(".ImgOnly").removeClass("selResultType");
            $(".Details").removeClass("selResultType");
            $(".itemHolder").css("display", "inline-block");
            tl.insert(TweenMax.to($(".detailListHeader"), .2, { css: { autoAlpha: 0, display: 'none' } }), 0);
            tl.insert(TweenMax.to($(".DetailListView"), .2, { css: { autoAlpha: 0, display: 'none' } }), 0);
            tl.insert(TweenMax.to($(".ImageAndTitleView"), .4, { css: { autoAlpha: 1, display: 'block' } }), 0);
            $(".staticTitleHolder").each(function () {
                var sth = $(this).data("height");
                if (typeof sth === "undefined" || sth == 0) { sth = "auto"; }
                tl.insert(TweenMax.to($(this), .4, { css: { height: sth, autoAlpha: 1, display: 'block' } }), 0);
            });

            $(".ActivityImg").off();
            $(".ActivityImg").hover(
                function () {
                    $(this).find(".HoverTextHolder").show().css("display", "table");
                },
                function () {
                    $(this).find(".HoverTextHolder").hide();
                }
            );
            NextArrow();
        } else if (resultListType == 1) {
            // image only
            $(".ImgOnly").addClass("selResultType");
            $(".Details").removeClass("selResultType");
            $(".ImgAndTitle").removeClass("selResultType");
            $(".itemHolder").css("display", "inline-block");
            tl.insert(TweenMax.to($(".detailListHeader"), .2, { css: { autoAlpha: 0, display: 'none' } }), 0);
            tl.insert(TweenMax.to($(".DetailListView"), .2, { css: { autoAlpha: 0, display: 'none' } }), 0);
            tl.insert(TweenMax.to($(".ImageAndTitleView"), .4, { css: { autoAlpha: 1, display: 'block' } }), 0);
            var maxHeight = 0;
            $(".staticTitleHolder").each(function () {
                maxHeight = Math.max(maxHeight, $(this).height());
                $(this).data("height", maxHeight);
            });

            tl.insert(TweenMax.to($(".staticTitleHolder"), .4, { css: { height: 0, display: 'none', autoAlpha: 0 } }), 0);
            $(".ActivityImg").hover(
                function () {
                    $(this).find(".HoverTitle").slideDown();
                    $(this).find(".HoverTextHolder").show().css("display", "table");
                },
                function () {
                    $(this).find(".HoverTitle").slideUp();
                    $(this).find(".HoverTextHolder").hide();
                }
            );
            NextArrow();
        } else if (resultListType == 2) {
            // details
            $(".Details").addClass("selResultType");
            $(".ImgOnly").removeClass("selResultType");
            $(".ImgAndTitle").removeClass("selResultType");
            $(".itemHolder").css("display", "block");
            $(".staticTitleHolder").each(function () {
                var sth = $(this).data("height");
                if (typeof sth === "undefined") { sth = "auto"; }
                tl.insert(TweenMax.to($(this), .4, { css: { height: sth, autoAlpha: 1, display: 'block' } }), 0);
            });
            tl.insert(TweenMax.to($(".ImageAndTitleView"), .2, { css: { autoAlpha: 0, display: 'none' } }), 0);
            tl.insert(TweenMax.to($(".detailListHeader"), .4, { css: { autoAlpha: 1, display: 'table' } }), 0);
            tl.insert(TweenMax.to($(".DetailListView"), .4, { css: { autoAlpha: 1, display: 'table' } }), 0);
            $("#NextArrow").css("display", "none");
        } else {
            // fun, do nothing
        }

        tl.play();

        $("#LoadingOverlay").fadeOut(700);
    }

    var NextArrow = function () {
        var ctrl = $("#NextArrow");
        var count = $(".itemHolder").length;
        var eachRow = Math.floor($("#searchResults").width() / 204);
        var remainder = count % eachRow;
        if (remainder > 0 && typeof $("a[rel='next']").attr("href") !== "undefined" && $("a[rel='next']").attr("href").indexOf("void") == -1) {
            ctrl.css("display", "inline-block");
        } else {
            ctrl.css("display", "none");
        }
    }

    var hideUs = function (ctrl, completeCtrl) {
        ctrl.fadeOut('fast', showUs(completeCtrl));
    }

    var showUs = function (ctrl) {
        if (ctrl.css("display") == "none") {
            ctrl.show("slow");
        }
    }

    function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)", "i"),
            results = regex.exec(location.search);
        return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    // reloads the results page based on the values of the search form, including the two hidden  fields for activity category id and tags
    var loadResults = function (query, sf, srt) {
        var href = $("#clearLink").attr("href");
        var first = "?";
        var amp = "";
        var newTags = "";
        if ($('#actCatId').val() != '') {
            href = href + first + amp + "actCatId=" + $('#actCatId').val()
            first = ""; amp = "&";
        }
        if ($('#actTags').val() != '') {
            href = href + first + amp + "actTags=" + $('#actTags').val()
            first = ""; amp = "&";
        }
        if (query.val() != '' && query.val() != defaultSearchValue) {
            href = href + first + amp + "actTerms=" + query.val()
            first = ""; amp = "&";
        }

        if ($('#page').val() != '') {
            href = href + first + amp + "page=" + $('#page').val()
            first = ""; amp = "&";
        }

        if (getParameterByName("useNewTagging") != "") {
            newTags = "&useNewTagging=1";
        }

        href = href + first + amp + "actFilter=" + sf.val() + newTags + "&resultType=" + $(".selResultType").attr("type");
        $("#reloadLink").attr("href", href);
        $("#reloadLink").click();
    }

    return {
        init: init
    };
})();

IREP.LearningTagSearch = (function () {
    var _tagAnimationSpeed = 500;
    var mainPage;
    var init = function (actTags, mp) {
        mainPage = mp;
        $("#tagSectionTitle").click(function () {
            if ($(this).data("showing") == 0) {
                $(this).data("showing", 1);
                TweenMax.to($("#tagMain"), .4, { height: 'auto', autoAlpha: 1, display: 'block' });
            } else {
                $(this).data("showing", 0);
                TweenMax.to($("#tagMain"), .4, { height: 0, autoAlpha: 0, display: 'none' });
            }
        });

        $(".tagListCheckbox").change(function () {
            var $thisLabel = $(this).next();
            $thisLabel.toggleClass("checked", this.checked);
        });

        if (actTags != "") {
            actTags = actTags.split(",");
            for (var j = 0; j < actTags.length; j++) {
                var tagArray = actTags[j].split("!");
                $("#filter_option" + tagArray[1]).prop('checked', true);
                $("#filter_option" + tagArray[1]).change();
                $("#filter_option" + tagArray[1]).parent().data('myHeight', $("#filter_option" + tagArray[1]).parent().height());
            }
        }

        // Minimize upon load
        $(".tagHeader").each(function () {
            showHideUnchecked($(this), 0, 0, false);
        });

        // Handle Clicks on the header to show/hide a category
        $(".tagHeader").click(function () {
            showHideUnchecked($(this), 0, 0, true);
        });

        // Handle Clicks on the "Apply" resp. "Clear" links
        $(".tagApplyClear").click(function () {
            applyTags($(this));
            return false;
        });

        mainPage.on('loadResults', function (event, actCatId, actTags) {
            if (actTags == " " && actCatId != " ") {
                $("#tagSectionTitle").data("showing", 0);
                $(".tagHeader").each(function () { clearAll($(this), false); });
                TweenMax.to($("#tagMain"), .4, { height: 0, autoAlpha: 0, display: 'none' });
            }
        });
    };

    var applyTags = function (myDiv) {
        var myHeader = myDiv.parent().parent();

        // Flip-flop the links:
        if ($(myHeader).find("#divApply").is(":visible") == true) {
            // User clicked "Apply"
            showHideUnchecked(myHeader, 1, 0, true);
        } else {
            // User clicked "Clear - Clear all the flags, and collapse:
            showHideUnchecked(myHeader, 0, 1, true)
        }
    }

    var clearAll = function (myHeader, reloadResults) {
        $(myHeader).next().find('input').each(function () {
            // Collapse each item that was previously checked
            if (this.checked) {
                this.checked = false;

                var $thisLabel = $(this).next();
                $thisLabel.toggleClass("checked", this.checked);
            }
            $(this).parent().slideUp();
        });

        $(myHeader).find('#divApplyClear').hide();
        $(myHeader).find('#divSelIndicator').animate({ width: "0px", right: "0px" }, _tagAnimationSpeed);

        $(myHeader).data('showing', 0);

        // Refresh the search grid:
        if (reloadResults) {
            applyTagSelectionToGrid();
        }
    }

    var showHideUnchecked = function (myHeader, applyClicked, clearClicked, reloadResults) {
        var myData = $(myHeader).data('showing');

        // Process by filter option and hide if not checked:
        if (typeof myData === "undefined") {
            // If undefined we are hiding for the first time:
            myData = 1;
        };

        if (clearClicked == 1) {
            // Items are currently flagged, and clear was clicked.

            $(myHeader).next().find('input').each(function () {
                // Collapse each item that was previously checked
                if (this.checked) {
                    this.checked = false;
                    var $thisLabel = $(this).next();
                    $thisLabel.toggleClass("checked", this.checked);
                }
                $(this).parent().slideUp();
            });

            $(myHeader).find('.divApplyClear').hide();
            $(myHeader).find('#divSelIndicator').animate({ width: "0px", right: "0px" }, _tagAnimationSpeed);
            //   $(myHeader).removeClass('selectedSearch');

            // Refresh the search grid:
            if (reloadResults) {
                applyTagSelectionToGrid();
            }
        } else if (myData == 1) {
            // Currently showing show all items. Let's apply and hide unchecked.
            $(myHeader).data('showing', 0);

            var myCheckedCtr = 0;

            $(myHeader).next().find('input').each(function () {
                if (!this.checked) {
                    // Save the current height:
                    if (typeof $(this).parent().data('myHeight') == "undefined") {
                        // Only store this on the first click to avoid random clicks storing odd heights.
                        $(this).parent().data('myHeight', $(this).parent().height());
                    };
                    // Downsize...
                    $(this).parent().slideUp();
                } else {
                    // Keep track of how many were checked...
                    myCheckedCtr += 1;
                    $(this).parent().slideDown();
                };
            });

            // Either hide the "Apply" link or change to "Clear" if items were selected.
            if (myCheckedCtr > 0) {
                // Items are checked. Change to the "Clear" link:
                $(myHeader).find('#divSelIndicator').animate({ width: "10px", right: "-10px" }, _tagAnimationSpeed);
                $(myHeader).find('.divApplyClear').show();
                //    $(myHeader).addClass('selectedSearch');
                $(myHeader).find("#divApply").hide();
                $(myHeader).find("#divClear").show();
            } else {
                // User might have unchecked items instead of clicking "Clear". Do we need to hide indicator?
                if ($(myHeader).find('#divSelIndicator').width() > 0) {
                    $(myHeader).find('#divSelIndicator').animate({ width: "0px", right: "0px" }, _tagAnimationSpeed);
                    //     $(myHeader).removeClass('selectedSearch');
                }
                $(myHeader).find('.divApplyClear').hide();
            };

            // Refresh the search grid:
            if (reloadResults) {
                applyTagSelectionToGrid();
            }
        } else {
            // We are showing the list of tags for a category:
            $(myHeader).data('showing', 1);

            $(myHeader).next().find('input').each(function () {
                if (!this.checked) {
                    // Get the previous height:
                    var oldHeight = $(this).parent().data('myHeight');
                    oldHeight = oldHeight + 'px';

                    $(this).parent().slideDown();
                };
            });
            // Show the "Apply" link:
            $(myHeader).find('.divApplyClear').show();
            $(myHeader).find("#divApply").show();
            $(myHeader).find("#divClear").hide();
        };
    };

    var applyTagSelectionToGrid = function () {
        // The tag selection changed. We need to reapply the selection:

        var myTagSelection = "";
        var myTagSelectionArray = new Array();

        // Loop through all the headers...
        $('.tagHeader').each(function () {
            // Now loop through all the checkboxes
            $(this).next().find('input').each(function () {
                if (this.checked) {
                    myTagSelection = myTagSelection + $(this).val() + ", ";
                    myTagSelectionArray.push($(this).val());
                }
            });
        });

        if (myTagSelection != "") {
            // Refresh the search grid:
            mainPage.trigger('loadResults', [" ", myTagSelectionArray.join(","), 1]);
        } else {
            // For testing only, display selection :
            mainPage.trigger('loadResults', [" ", " ", 1]);
        }
    };

    return {
        init: init
    };
})();

IREP.LearningCategories = (function () {
    var _tagAnimationSpeed = 500;

    var init = function (actCatId, mp) {
        if (actCatId) {
            toggleCategory($(".category[catid='" + actCatId + "']"));
        }

        $("#activitySectionTitle").data("height", $(".ActivityCategoryControl").height());

        $(".ActCategory").click(function () {
            $(".divApplyClear").css("display", "none");
            toggleCategory($(this));
        });

        $("#activitySectionTitle").click(function () {
            if ($(this).data("showing") == 0) {
                $(this).data("showing", 1);
                TweenMax.to($(".ActivityCategoryControl"), .4, { height: $(this).data("height"), autoAlpha: 1, display: 'block' });
            } else {
                $(this).data("showing", 0);
                TweenMax.to($(".ActivityCategoryControl"), .4, { height: 0, autoAlpha: 0, display: 'none' });
            }
        });

        mp.on('loadResults', function (event, actCatId, actTags) {
            if (actCatId == " ") {
                $(".category").attr("on", "false");
                $(".category").find('.divSelIndicator').animate({ width: "0px", right: "0px" }, _tagAnimationSpeed);
                //   $(".category").removeClass('selectedSearch');
                $(".ActCategory > .divApplyClear").css("display", "none");

                if ($("#activitySectionTitle").data("showing") != 0 && actTags != " ") {
                    $("#activitySectionTitle").click();
                }
            }
        });
    };

    var toggleCategory = function (ctrl) {
        if (ctrl.attr("on") == "true") {
            ctrl.attr("on", "false");
            ctrl.trigger('loadResults', [" ", " ", 1]);
            ctrl.find('.divSelIndicator').animate({ width: "0px", right: "0px" }, _tagAnimationSpeed);
            //   ctrl.removeClass('selectedSearch');
            ctrl.find(".divApplyClear").css("display", "none");
        } else {
            $('.divSelIndicator').animate({ width: "0px", right: "0px" }, 200);
            $(".category").attr("on", "false");
            ctrl.attr("on", "true");
            ctrl.trigger('loadResults', [ctrl.attr("catid"), " ", 1]);
            ctrl.find('.divSelIndicator').animate({ width: "10px", right: "-10px" }, _tagAnimationSpeed);
            //   ctrl.addClass('selectedSearch');
            ctrl.find(".divApplyClear").css("display", "block");
        }
    }

    return {
        init: init
    };
})();

IREP.LearningResultList = (function () {
    var _tagAnimationSpeed = 500;
    var init = function () {
        var url = location.search.toLowerCase();
        if (url.indexOf("actcode=") != -1 && url.indexOf("al=") != -1) {
            var actcode = getActCode(location.search);
            showDrawer($(".ImageAndTitleView[actcode='" + actcode + "']"));

            if (url.indexOf("tab=1") != -1) {
                $(".detailInfo").click();
            } else {
                var hasTakenTrainingSurvey = sessionStorage.getItem(IREP.options.user.currentUID + "_" + actcode + "_HasTakenTrainingSurvey");

                var site = IREP.options.user.site;
                if (hasTakenTrainingSurvey === null || hasTakenTrainingSurvey === "0") { //show survey upon finishing a training if not taken yet.
                    $(".detail-Survey").trigger("click");
                } else {
                    if (url.indexOf("cm=") != -1) {
                        //$(".detailActivityCommentsWrapper").slideDown(200, function () {
                        //    if (!$(".activityDetailContainer").find('.commentsContainer').hasClass('mCustomScrollbar')) {
                        //        $(".activityDetailContainer").find('.commentsContainer').mCustomScrollbar({
                        //            theme: 'dark-thick',
                        //            scrollButtons: {
                        //                enable: true
                        //            }
                        //        });
                        //    }
                        //});
                        $(".detailComments").click();
                    } else {
                        $(".detailInfo").click();
                    }
                }
            }
        }
        $(".ActivityImg").hover(
            function () {
                //$(this).find(".HoverTextHolder").show().css("display", "table");
                TweenMax.to($(this).find(".HoverTextHolder"), 0, { autoAlpha: 1, display: 'table' });
            },
            function () {
                //$(this).find(".HoverTextHolder").hide();
                TweenMax.to($(this).find(".HoverTextHolder"), 0, { autoAlpha: 0, display: 'none' });
            }
        );

        // add the top pager to its spot
        $("#topPagerHolder").html("");
        $("#topPagerHolder").append($("#topPager").html());
        $("#topPager").remove();

        $('a[rel]').click(function () {
            if ($(this).attr("href").indexOf("void") == -1) {
                $(this).trigger('loadResults', [null, null, $(this).attr("pagenum")]);
            }
            return false;
        });

        $("#NextArrow").click(function () {
            $(this).trigger('loadResults', [null, null, $("a[rel='next']").attr("pagenum")]);
            return false;
        });

        $(".detailListCertificate").click(function (e) {
            e.stopPropagation();
        });

        $(".ImageAndTitleView, .DetailListView").click(function () {
            showDrawer($(this));
        });

        $(".ModalView").click(function () {
            closeModal();
        });
    };

    var showRating = function (rating, original) {
        // var count = 1;
        var test = $(".activityDetailContainer").find('#imgThumb' + rating);
        test.attr("src", test.attr("src").replace("Grey", "Blue"));

        //while (count <= rating) {
        //    var lightUp = $(".activityDetailContainer").find('#imgStar' + count.toString());
        //    lightUp.attr("src", lightUp.attr("src").replace("dark", "light"));
        //    count++;
        //}
        //while (count <= 5) {
        //    var goDark = $(".activityDetailContainer").find('#imgStar' + count.toString());
        //    goDark.attr("src", goDark.attr("src").replace("light", "dark"));
        //    count++;
        //}
    }

    var showOriginal = function () {
        // showRating(0, 0);
        var lightUpOne = $(".activityDetailContainer").find('#imgThumb1');
        lightUpOne.attr("src", lightUpOne.attr("src").replace("Blue", "Grey"));

        var lightUpTwo = $(".activityDetailContainer").find('#imgThumb0');
        lightUpTwo.attr("src", lightUpTwo.attr("src").replace("Blue", "Grey"));
    }

    var resizeHoverText = function (ctrl) {
        var test = ctrl.find(".HoverTextHolder");
        test.height(test.parent().innerHeight());
        test.width(test.parent().innerWidth());
    }

    var scrollItemToDrawer = function (ctrl) {
        var ControlToUse = ctrl.find("*").addBack().filter(".borderWrapper");

        if (ControlToUse.offset().top + ControlToUse.outerHeight() < $(".activityDetailContainer").offset().top) {
            $("html,body").animate({ scrollTop: $(window).scrollTop() - ($(".activityDetailContainer").offset().top - ControlToUse.offset().top - ControlToUse.outerHeight()) }, 'fast');
        }
        else {
            $("#scrollSpacer").css("height", (ControlToUse.offset().top + ControlToUse.outerHeight()) - $(".activityDetailContainer").offset().top + 150);
            $("html,body").animate({ scrollTop: $(window).scrollTop() + (ControlToUse.offset().top + ControlToUse.outerHeight() - $(".activityDetailContainer").offset().top) }, 'fast');
        }
    }

    var showDrawer = function (ctrl) {
        var detailDiv = $("div.DetailView[actcode='" + ctrl.attr("actcode") + "']").first();

        $.ajax({
            type: "POST",
            contentType: "application/json; charset=utf-8",
            url: "Learning/ActivityCommentsList.ajax?actCode=" + ctrl.attr("actcode"),
            success: function (msg) {
                $(".activityDetailContainer").find('.commentsContainer').html(msg);
            },
            error: function (xhr, textStatus, errorThrown) {
            }
        });

        var borderWrapper = ctrl.find("*").addBack().filter(".borderWrapper");
        var tl = new TimelineMax();
        if (ctrl.attr("ClickedImageTitle") == 'true') {
            tl.insert(TweenMax.to(borderWrapper, .1, { css: { border: "3px solid white", marginLeft: "0px", marginTop: "0px" } }), 0);
            tl.insert(TweenMax.to($(".activityDetailContainer"), .4, { height: 0, autoAlpha: 0, display: 'none', onComplete: removeDetail, onCompleteParams: [$(".activityDetailContainer")] }), 0);
            tl.insert(TweenMax.to($(".ModalView"), .4, { display: 'none', autoAlpha: 0 }), 0);
            //$(".ModalView").fadeOut(200);
            ctrl.attr("ClickedImageTitle", "false");
            ctrl.css("z-index", 0);
            $("#scrollSpacer").css("height", "0px");
        } else {
            ctrl.css("z-index", 91);
            tl.insert(TweenMax.to($(".ModalView"), .4, { autoAlpha: 0.4, display: 'block' }), 0);
            tl.insert(TweenMax.to(borderWrapper, .1, { css: { border: "10px solid #0071c5", marginLeft: "-5px", marginTop: "-5px" } }), 0);
            $("<div>").addClass("activityDetailContainer").append(detailDiv.html()).appendTo("#searchResults");
            resizeHoverText($(".activityDetailContainer"));
            tl.insert(TweenMax.to($(".activityDetailContainer"), .4, { height: "446px", autoAlpha: 1, display: 'block', onComplete: scrollItemToDrawer, onCompleteParams: [ctrl] }), 0);
            ctrl.attr("ClickedImageTitle", "true");

            //   $("html,body").animate({scrollTop: $(this).offset().top + $(this).height()},'fast');
        }
        tl.play();

        $(".detailActivityClose").click(function () {
            closeModal();
        });

        /* 2014-05-2014 Page Drawer Update - Nav
        **************************************** */
        var isActive = "survey-Panel",
          img_src = "",
          new_src = "";

        $(".mouseover").hover(function () {
            img_src = $(this).attr('src');
            new_src = $(this).attr('rel');
            $(this).attr('src', new_src);
            $(this).attr('rel', img_src);
        },
        function () { //mouse out
            $(this).attr('src', img_src);
            $(this).attr('rel', new_src);
        });
        var cache = new Array();
        $(".mouseover").each(function () {
            var cacheImage = document.createElement('img');
            cacheImage.src = $(this).attr('rel');
            cache.push(cacheImage);
        });
        $(".detailInfo").click(function () {
            isActive = "detail-Panel";
            $(".detail-Panel").fadeIn(800, function () { });
            $(".close-Panel").fadeIn(800, function () { });
            $(".quotes-Panel").hide();
            $(".survey-Panel").hide();
            $(".tagging-Panel").hide();
        });

        $(".detailComments")
            .click(function () {
                isActive = "quotes-Panel";
                $(".quotes-Panel").fadeIn(800, function () { });
                $(".close-Panel").fadeIn(800, function () { });
                $(".detail-Panel").hide();
                $(".survey-Panel").hide();
                $(".tagging-Panel").hide();
            });

        $(".detail-Tags")
           .click(function () {
               isActive = "tagging-Panel";
               $(".tagging-Panel").fadeIn(800, function () { });
               $(".close-Panel").fadeIn(800, function () { });
               $(".detail-Panel").hide();
               $(".survey-Panel").hide();
               $(".quotes-Panel").hide();
           });

        $(".detail-Survey").click(function (e) {
            isActive = "survey-Panel";
            $(".survey-Panel").fadeIn(800, function () { });
            $(".close-Panel").fadeIn(800, function () { });
            $(".quotes-Panel").hide();
            $(".detail-Panel").hide();
            $(".tagging-Panel").hide();

            //Training should not display anyway
            //   var hasTakenTrainingSurvey = sessionStorage.getItem(IREP.options.user.currentUID + "_" + ctrl.attr("actcode") + "_HasTakenTrainingSurvey");
            //  if (hasTakenTrainingSurvey == null || hasTakenTrainingSurvey === 0) { //get survey only if not taken yet
            if ($(".activityDetailContainer").find('.surveyContainer').html() == "") {//make sure we don't get it again if already there
                $.ajax({
                    type: "POST",
                    contentType: "application/json; charset=utf-8",
                    url: "Learning/ActivitySurvey.ajax?actCode=" + ctrl.attr("actcode"),
                    success: function (html) {
                        $(".activityDetailContainer").find('.surveyContainer').html(html);
                    },
                    error: function (xhr, textStatus, errorThrown) {
                    }
                    //}
                });
            }
            e.stopPropagation();
        });


        $('.rating').bind({
            click: function () {
                rate(this);
            },
            mouseenter: function () {
                showRating(parseInt(this.id.substring(8, 9)), 1);
            },
            mouseout: function () {
                showOriginal();
            }
        });
        $(".addComment").click(function () {
            $.ajax({
                type: "POST",
                contentType: "application/x-www-form-urlencoded; charset=utf-8",
                url: "Learning/ActivityCommentsList.ajax?AddComment=",
                data: { actCode: $(this).attr("actCode"), commentText: $(".activityDetailContainer").find('#txtComment').val(), commentID: $(".activityDetailContainer").find('#txtCommentId').val() },
                success: function (msg) {
                    $(".activityDetailContainer").find('.commentsContainer').html(msg);
                    $(".activityDetailContainer").find(".commentsContainer").mCustomScrollbar({ theme: 'dark-thick', scrollButtons: { enable: true } });
                    if ($(".activityDetailContainer").find('#txtCommentId').val() == "") {
                        $(".activityDetailContainer").find(".commentsContainer").mCustomScrollbar("scrollTo", "bottom");
                    } else {
                        $(".activityDetailContainer").find(".commentsContainer").mCustomScrollbar("scrollTo", ".commentId-" + $(".activityDetailContainer").find('#txtCommentId').val());
                    }
                    $(".activityDetailContainer").find('#txtComment').val("");
                    $(".activityDetailContainer").find('#txtCommentId').val("");
                },
                error: function (xhr, textStatus, errorThrown) {
                }
            });
        });
        $(document).on("keypress", ".submitComment", function (event) {
            if (event.which == "13") {
                $(".addComment", this).click();
                return false;
            }
        });
        $(".activityDetailContainer").find(".detailInfo").click();
        $(".activityDetailContainer").trigger("irep.drawer.open");


        var filterCollectionId = $("div.DetailView[actcode='" + ctrl.attr("actcode") + "'] .DetailContentsRightContent.tagging-Panel").attr("data-filtercollectionid");
        // if it doesn't have a filtercollectiond, add one

        if (!filterCollectionId) {
            IREP.callApi("Filters/NewFilterCollection",
                  "POST",
                  {
                      filterType: 'activity',
                      id: ctrl.attr("actId")
                  }).done(function (data) {
                      if (data !== null) {

                          var url = IREP.generateSiteLink("/editor/filters/" + data.filterCollectionId);

                          $(".activityDetailContainer").find(".taggingDiv").load(url);
                      }
                  });
        } else {
            var url = IREP.generateSiteLink("/editor/filters/" + filterCollectionId);

            $(".activityDetailContainer").find(".taggingDiv").load(url);
        }
    };

    var rate = function (clickedRating) {

        var rating = clickedRating.id.substring(8, 9);
        var actCode = $(clickedRating).parents(".detail-Panel").attr("actcode");
        var toggleClass = $(".detail-Panel[actcode='" + actCode + "']");

        //  console.log("Activity Code " + actCode, toggleClass);

        var postdata = {
            actcode: actCode,
            rating: rating,
            typeid: 252
        };


        IREP.callApi("activity/thumbsRating", "POST", postdata)
            .done(function (data) {
                // console.log(data);
                //$(".activitydetailcontainer").find(".rateme").css({ "display": "none" });
                // $(".activitydetailcontainer").find(".ratedme").css({ "display": "block" });
                // toggleClass.find(".RatedMe .detailValue").html(data + "/5");
                toggleClass.find(".RateMe").fadeOut(1500).css({ "display": "none" });
                toggleClass.find(".RatedMe").fadeIn(2000).css({ "display": "block" });

                var thumbsup = Math.round(data.thumbsUpAvg);
                var thumbsdown = Math.round(data.thumbsDownAvg);

                if (data.castedVote == 1) {
                    toggleClass.find(".RatedMe .detailValue").html("<img class='rating' id='imgThumb' style='padding-left: 5px;' src='/50/Content/images/Ratings/Thumb-Up-Blue.png'>" + " " + thumbsup + "%" + " " + "<img class='rating' id='imgThumb' style='padding-left: 5px;' src='/50/Content/images/Ratings/Thumb-Down-Grey.png'>" + " " + thumbsdown + "%");
                }
                else {
                    toggleClass.find(".RatedMe .detailValue").html("<img class='rating' id='imgThumb' style='padding-left: 5px;' src='/50/Content/images/Ratings/Thumb-Up-Grey.png'>" + " " + thumbsup + "%" + " " + "<img class='rating' id='imgThumb' style='padding-left: 5px;' src='/50/Content/images/Ratings/Thumb-Down-Blue.png'>" + " " + thumbsdown + "%");
                }
            });
    }

    var getActCode = function (url) {
        var sub1 = url.substring(url.toLowerCase().indexOf("actcode"));
        if (sub1.indexOf("&") != -1) {
            sub1 = sub1.substring(0, sub1.indexOf("&"));
        }
        var splitme = sub1.split("=");
        return splitme[1];
    };

    var closeModal = function (ctrl) {
        var tl = new TimelineMax();

        $(".detailActivityCommentsWrapper").slideUp();
        tl.insert(TweenMax.to($(".borderWrapper"), .1, { css: { border: "3px solid white", marginLeft: "0px", marginTop: "0px" } }), 0);
        tl.insert(TweenMax.to($(".activityDetailContainer"), .4, { height: 0, autoAlpha: 0, display: 'none', onComplete: removeDetail, onCompleteParams: [$(".activityDetailContainer")] }), 0);
        tl.insert(TweenMax.to($(".ModalView"), .4, { display: 'none', autoAlpha: 0 }), 0);
        $(".ImageAndTitleView, .DetailListView").attr("ClickedImageTitle", "false");
        $(".ImageAndTitleView, .DetailListView").css("z-index", 0);
        tl.play();
        $("#scrollSpacer").css("height", "0px");
    }

    var removeDetail = function (ctrl) {
        ctrl.remove();
    }

    return {
        init: init
    };
})();

//Survey Function
IREP.ActivitySurvey = (function () {
    var currentSquare, activityUID, hidQuestion5Id, hidQuestion5AnswerId, errorMsg, activityCode, question1Answered, question2Answered, successfulMsg, toolId;
    var init = function (options) {
        activityUID = options.activityUID;
        hidQuestion5Id = options.hidQuestion5Id;
        hidQuestion5AnswerId = options.hidQuestion5AnswerId;
        activityCode = options.activityCode;
        toolId = options.toolId;
        errorMsg = options.errorMsg;
        currentSquare = 1;
        question1Answered = 0;
        question2Answered = 0;
        successfulMsg = options.successfulMsg;

        $(".submit").click(function (e) {
            postSurvey();
            return false;
            e.preventDefault();
        });

        //Fixed Function
        var question5Val = null;
        $('#question5Answer').on('keyup', function (e) {
            question5Val = $('#question5Answer').val().length;
            if (question5Val > 0)
                $(".page-block-submit").css("display", "block");
            else
                $(".page-block-submit").css("display", "hidden");
        });

        $('input:radio').change(function () {
            showHideNav();
        });

        var isActive = "detail-Panel",
          navClicked = false,
          previousPage = 1,
          currentPageBlock = 1,
          nextPageBlock = 0,
          PageBlockCount = $(".NumQuestion").length,
          CountPage = 0;

        $(".page-block-arrow-right").click(function (e) {
            if (navClicked == false) {
                $(".page-block-arrow-right").css("visibility", "hidden");
            }

            if (currentPageBlock < PageBlockCount) {
                $(".page-block-arrow-left").css("visibility", "visible");
                currentPageBlock = previousPage + 1;
                $(".survey-question-container-" + currentPageBlock + "").fadeIn(800, function () { });
                $(".survey-question-container-" + previousPage + "").hide();
                $("#" + currentPageBlock + "b").addClass("Active");
                $("#" + previousPage + "b").removeClass("Active");
                previousPage = currentPageBlock;
            }
            //Checks Value on Revisit
            if (currentPageBlock == PageBlockCount) {
                $(".page-block-arrow-right").css("visibility", "hidden");

                question5Val = $('#question5Answer').val().length;
                if (question5Val > 0) {
                    $(".page-block-submit").css("display", "block");
                    $(".page-block-arrow-right").css("visibility", "hidden");
                }
            }
            navClicked = true;
            e.stopPropagation();
        });

        $(".page-block-arrow-left").click(function (e) {
            currentPageBlock = currentPageBlock - 1;
            $(".page-block-submit").css("display", "none");
            $(".page-block-arrow-right").css("visibility", "visible");
            $(".survey-question-container-" + currentPageBlock + "").fadeIn(800, function () { });
            $(".survey-question-container-" + previousPage + "").hide();
            $("#" + previousPage + "b").removeClass("Active");
            $("#" + currentPageBlock + "b").addClass("Active");
            previousPage = previousPage - 1;
            if (currentPageBlock == 1) {
                $(".page-block-arrow-left").css("visibility", "hidden");
            }
            e.stopPropagation();
        });
    };

    var postSurvey = (function () {
        var answers = [];
        var answer = {//answer to question 1
            QuestionId: $('input[name=question0]:checked').attr('id'), AnswerId: $('input[name=question0]:checked').val(), Correct: true, Text: ''
        };
        answers.push(answer);

        answer = {//answer to question 2
            QuestionId: $('input[name=question1]:checked').attr('id'), AnswerId: $('input[name=question1]:checked').val(), Correct: true, Text: ''
        };
        answers.push(answer);

        answer = {//answer to question 3
            QuestionId: $('input[name=question2]:checked').attr('id'), AnswerId: $('input[name=question2]:checked').val(), Correct: true, Text: ''
        };
        answers.push(answer);

        answer = {//answer to question 4
            QuestionId: $('input[name=question4]:checked').attr('id'), AnswerId: $('input[name=question4]:checked').val(), Correct: true, Text: ''
        };
        answers.push(answer);

        answer = {//answer to question 5
            QuestionId: hidQuestion5Id, AnswerId: hidQuestion5AnswerId, Correct: true, Text: $('#question5Answer').val()
        };
        answers.push(answer);

        var data = { PaxUID: IREP.options.user.currentUID, ActivityUID: activityUID, SurveyCode: activityCode, ToolId: toolId, Results: answers };

        IREP.callApi("quiz/results", "POST", data)
           .done(function (data) {
               if (data != null) {
                   $(".title").css({ "margin-top": "100px", "margin-left": "200px" })
                   $(".title").text(successfulMsg).fadeOut(2000, function () {
                       $(".detailInfo").trigger("click");
                   });

                   sessionStorage.setItem(IREP.options.user.currentUID + "_" + activityCode + "_HasTakenTrainingSurvey", 1);
                   $(".page-block-success-message").css("display", "block").text(successfulMsg);
                   $(".surveyContainer .detailsHeadline").hide();
                   $(".DetailView[actcode='" + activityCode + "'] .detail-Survey").hide(); /* Hide the survey just for this one item */
                   $(".activityDetailContainer .detail-Survey").hide();
                   $(".commentText", ".surveyContainer").hide();
                   $(".pagination-Container").hide();
                   $(".survey-question-container-3").hide();
                   $(".page-block-success-message").fadeOut(2200, function () {
                       $(".detail-Panel").show();
                   });
               }

               if (toolId != null) {
                   $(".dvToolItem[data-id='" + toolId + "']").attr('data-surveytaken', 'True');
               }
           })
            .fail(function () {
                $(".page-block-error-message").css("display", "block").text(errorMsg);
            })
    });

    var showHideNav = (function () {
        var count = 0;
        $('input:radio').each(function (index) {
            if ($(this).is(':checked') == true)
                count++;
        });
        if ((count === 3) && question1Answered === 0) {
            question1Answered = 1;
            $(".page-block-arrow-right").css("visibility", "visible");
        }
        else if ((count === 4) && question2Answered === 0) {
            $(".page-block-arrow-right").css("visibility", "visible");
            question2Answered = 1;
        }
    });

    return {
        init: init
    };
})();

IREP.ActivityComments = (function () {
    var init = function () {
    };

    return {
        init: init
    };
})();

IREP.ActivityCommentsList = (function () {
    var init = function () {
        $(".commentsRow").hover(function () { $(this).find(".flag").css("visibility", "visible"); }, function () { $(this).find(".flag").css("visibility", "hidden"); });
        $(".commentsRow").hover(function () { $(this).find(".edit").css("visibility", "visible"); }, function () { $(this).find(".edit").css("visibility", "hidden"); });
        $(".flag").hover(function () { $(this).css("color", "red"); $(this).children("img").css("background-color", "red"); }, function () { $(this).css("color", "#999999"); $(this).children("img").css("background-color", "#999999"); });
        $(".edit").hover(function () { $(this).css("color", "#F7CF00"); $(this).children("img").css("background-color", "#F7CF00"); }, function () { $(this).css("color", "#999999"); $(this).children("img").css("background-color", "#999999"); });

        $(".edit").click(function () {
            var commentRow = $(this).parents(".commentsRow");
            var commentId = commentRow.data("commentId");
            var commentText = commentRow.find(".commentText").html();
            $(".activityDetailContainer").find('#txtCommentId').val(commentId);
            $(".activityDetailContainer").find('#txtComment').val(commentText);
        });
    };
    return {
        init: init
    };
})();

IREP.LearningSkillsNav = (function () {
    var leftWidth = 85;
    var rightWidth = 85;

    var init = function (curPage) {
        if (curPage == 'skills') {
            showSkills();
        } else {
            localStorage.setItem("currentPage", "learning");
            $("#bottomLine").width($("#LearningNav").width());
            positionFooter();
        }

        $("#SkillsNav").click(function () {
            if (localStorage.getItem("currentPage") != 'skills') {
                showSkills();
            }
            return false;
        });

        $("#LearningNav").click(function () {
            if (localStorage.getItem("currentPage") == 'skills') {
                showLearning();
            }
            return false;
        });

        $("#form").css("height", "100%");
        $("Body").css("height", "100%");
        $("html").css("height", "100%");
        $("#contentContainer").css("height", "100%");
    }

    var hideoptions = {
        direction: 'left',
        mode: 'hide'
    };
    var showoptions = {
        direction: 'right',
        mode: 'show'
    };

    var showSkills = function () {
        var $left = rtlPosition('left');
        var $right = rtlPosition('right');
        $("#skillsDiv").css({ "display": "inline-block" });
        $(".leftNav").animate({ maxWidth: 0, opacity: 0 }, 400, "linear", function () { $(".leftNav").css("display", "none") });
        $(".rightNav").css({ "background-image": "none" });

        var rtl1 = { opacity: 1 };
        rtl1[$left] = "-=2000px";
        rtl1[$right] = "0";
        $("#learningDiv").delay(300).animate(rtl1, 1000);

        var rtl2 = { opacity: 1 };
        rtl2[$right] = "0";
        // rtl2[$left] = "0";
        $("#skillsDiv").delay(200).animate(rtl2, 1000);

        //  $("#learningDiv").delay(300).animate({ $left : "-=2000px" }, 1000);
        //   $("#skillsDiv").delay(200).animate({ right: 0 }, 1000);

        var left;
        IREP.options.isRTL ? left = $(window).width() - ($("#bottomLine").offset().left + $("#bottomLine").outerWidth()) : left = $("#bottomLine").offset().left;
        $("#SkillsNav").text($("#SkillsNav").text().replace(">", ""));

        var rtl3 = { opacity: 1 };
        rtl3[$left] = "auto";
        rtl3[$right] = $(window).width() - (left + $("#bottomLine").outerWidth());

        var rtl4 = { opacity: 1 };
        rtl4[$right] = "0";
        rtl4["width"] = $("#SkillsNav").width();
        $("#bottomLine").css(rtl3);

        $("#bottomLine").animate(rtl4, 1200, "linear", function () {
            var rtl5 = { opacity: 1 };
            rtl5[$left] = "auto";
            rtl5[$right] = "0";
            $("#bottomLine").css(rtl5);
        });

        if ($("#LearningNav").text().indexOf("<") == -1) {
            var newtext = "<" + $("#LearningNav").text();
            $("#LearningNav").text(newtext);
        }

        localStorage.setItem("currentPage", "skills");
        positionFooter();
    }

    $("#LearningNav").hover(
        function () {
            $("#LearningNav").addClass("current");
        },
        function () {
            $("#LearningNav").removeClass("current");
        }
    );

    $("#SkillsNav").hover(
        function () {
            $("#SkillsNav").addClass("current");
        },
        function () {
            $("#SkillsNav").removeClass("current");
        }
    );

    var showLearning = function () {
        var $left = rtlPosition('left');
        var $right = rtlPosition('right');

        var rtl1 = { opacity: 1 };
        rtl1[$left] = "0";
        $("#learningDiv").animate(rtl1, 1000);
        $("#LearningNav").text($("#LearningNav").text().replace("<", ""));

        var left;
        IREP.options.isRTL ? left = $(window).width() - ($("#SkillsNav").offset().left + $("#SkillsNav").outerWidth()) : left = $("#SkillsNav").position().left;
        var rtl2 = { opacity: 1 };
        rtl2[$left] = left;
        rtl2[$right] = "auto";
        $("#bottomLine").css(rtl2);

        var rtl3 = { opacity: 1 };
        rtl3[$left] = "0";
        rtl3["width"] = $("#LearningNav").width();
        $("#bottomLine").animate(rtl3, 1500, "linear", function () {
        });

        if ($("#SkillsNav").text().indexOf(">") == -1) {
            var newtext = $("#SkillsNav").text() + ">";
            $("#SkillsNav").text(newtext);
        }

        var rtl4 = { opacity: 1 };
        rtl4[$right] = "-2000px";

        var rtl5 = { opacity: 1 };
        rtl5[$left] = "auto";
        $("#skillsDiv").css(rtl5).animate(rtl4, 1000, function () { $("#skillsDiv").css({ "display": "none" }); });

        $(".leftNav").css("display", "table-cell");
        $(".leftNav").delay(800).animate({ maxWidth: "250px", opacity: 1 }, 500, "linear", function () { });
        $(".rightNav").css({ 'background-image': '' });
        localStorage.setItem("currentPage", "learning");
        positionFooter();
    }

    var positionFooter = function () {
        $("#footer").css("position", "auto");
        $("#footer").css("position", "fixed");
        $("#footer").css("bottom", "0");
    }

    var rtlPosition = function (initial) {
        var newdirection;

        if (IREP.options.isRTL) {
            initial == "left" ? newdirection = "right" : newdirection = "left";
        } else {
            newdirection = initial;
        }

        return newdirection;
    }

    return {
        init: init
    };
})();